import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';
import { applyTicket } from '@/utils/security';

const baseUrl = envConfig.formalServer + '/cotton/';

const baseApi = () => {
    function queryUserDetailInfo() {
        return Post(baseUrl + 'web/queryUserDetailInfo', null);
    }

    function sendPhoneCaptchaByAccount(data) {
        return Post(baseUrl + 'sendCaptchaByAccount', data);
    }

    function sendEmailCaptchaByAccount(data) {
        data.systemLanguage = getUserLanguage();
        return Post(baseUrl + 'sendEmailCaptchaByAccount', data);
    }

    function checkPhoneCaptcha(data) {
        return Post(baseUrl + 'checkPhoneCaptcha', data);
    }

    function checkEmailCaptcha(data) {
        return Post(baseUrl + 'checkEmailCaptcha', data);
    }

    function updateOrAddPhone(data) {
        return Post(baseUrl + 'updateOrAddPhone', data);
    }

    function updateOrAddEmail(data) {
        return Post(baseUrl + 'web/updateOrAddEmail', data);
    }

    function sendCaptchaByPhone(data) {
        let header = {};
        return applyTicket(header, 'SMS', data.phone).then(result => {
            return Post(baseUrl + 'sendCaptchaByPhone', data, { headers: header });
        });
    }

    function sendCaptchaByEmail(data) {
        let header = {};
        data.systemLanguage = getUserLanguage();
        return applyTicket(header, 'EMAIL', data.email).then(result => {
            return Post(baseUrl + 'sendEmailSms', data, { headers: header });
        });
    }

    function updatePassword(data) {
        return Post(baseUrl + 'updatePassword', data);
    }

    function updatePasswordByPhone(data) {
        return Post(baseUrl + 'updatePwdByPhone', data);
    }

    function updatePasswordByEmail(data) {
        return Post(baseUrl + 'web/updatePasswordByEmail', data);
    }

    function queryAccountInfoByContact(data) {
        return Post(baseUrl + 'web/queryAccountInfoByContact', data);
    }

    function judgeCaptchaByContact(data) {
        return Post(baseUrl + 'web/judgeCaptchaByContact', data);
    }

    function updateUserInfo(data) {
        return Post(baseUrl + 'web/updateUserInfo', data);
    }

    function deletePlayer() {
        return Post(baseUrl + 'deletePlayer', {});
    }

    function getUserLanguage() {
        let language = navigator.language.toLowerCase();
        if (language.startsWith('zh')) {
            return 'Chinese';
        } else {
            return 'English';
        }
    }

    return {
        sendPhoneCaptchaByAccount,
        sendEmailCaptchaByAccount,
        sendCaptchaByPhone,
        sendCaptchaByEmail,
        checkPhoneCaptcha,
        checkEmailCaptcha,
        updateOrAddPhone,
        updateOrAddEmail,
        updatePassword,
        updatePasswordByPhone,
        updatePasswordByEmail,
        queryAccountInfoByContact,
        judgeCaptchaByContact,
        updateUserInfo,
        deletePlayer,
        queryUserDetailInfo
    };
};

export const accountApi = baseApi();
